module.exports = __webpack_public_path__ + "media/components/src/assets/images/icons/icon-birthday-4334f3f66bba11df3a7530a15b90994a.png";